import React, { useState } from 'react';
import {
  makeStyles,
  TableRow,
  TableCell,
  Checkbox,
  IconButton,
  Collapse,
  Typography,
  Table,
  TableHead,
  TableBody,
  Card,
  CardContent,
} from '@material-ui/core';
import {
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { ptBR } from 'date-fns/locale';
import UTableHeading from 'components/UTableHead';

const useRowStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  card: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}));

function formatDate(data) {
  if (!data) {
    return '-';
  }
  return format(parseISO(data), 'dd/MM/yyyy HH:mm:ss', { locale: ptBR });
}

function Row({ row, selectedItems, handleChangeSelection }) {
  const [open, setOpen] = useState();
  const classes = useRowStyles();

  const isSelected = selectedItems.indexOf(row.id) !== -1;

  const handleClick = (event) => handleChangeSelection(event, row.id);

  return (
    <>
      <TableRow
        key={row.id}
        className={classes.root}
        selected={isSelected}
      >
        <TableCell padding="checkbox">
          <Checkbox
            inputProps={{ 'aria-label': 'select all' }}
            checked={isSelected}
            onChange={handleClick}
          />
        </TableCell>
        <TableCell component="th" scope="row">{row.codigoConsulta}</TableCell>
        <TableCell>{row.nomeAluno}</TableCell>
        <TableCell>{row.marca}</TableCell>
        <TableCell>{row.matricula}</TableCell>
        <TableCell>{row.cpf}</TableCell>
        <TableCell>{row.tipoCurso}</TableCell>
        <TableCell>{row.nomeCurso}</TableCell>
        <TableCell>{row.data}</TableCell>
        <TableCell>{row.responsavel}</TableCell>
        <TableCell>{row.situacao}</TableCell>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={11}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Card className={classes.card} variant="outlined">
              <CardContent>
                <Typography variant="h6" gutterBottom component="p">
                  Workflow de Assinaturas
                </Typography>
                <Table aria-label="assinaturas">
                  <TableHead>
                    <TableRow>
                      <UTableHeading>Ordem</UTableHeading>
                      <UTableHeading>Data Assinatura</UTableHeading>
                      <UTableHeading>Assinante</UTableHeading>
                      <UTableHeading>Concluído?</UTableHeading>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.assinatura.map((rowDetail) => (
                      <TableRow key={`${row.matricula}-workflow-${rowDetail.id}`}>
                        <TableCell component="th" scope="row">
                          {rowDetail.ordem}
                        </TableCell>
                        <TableCell>{formatDate(rowDetail.data)}</TableCell>
                        <TableCell>{rowDetail.responsavel}</TableCell>
                        <TableCell>
                          <Checkbox
                            checked={rowDetail.concluido}
                            disabled
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.number.isRequired,
    codigoConsulta: PropTypes.string.isRequired,
    nomeAluno: PropTypes.string.isRequired,
    marca: PropTypes.string.isRequired,
    matricula: PropTypes.number.isRequired,
    cpf: PropTypes.string.isRequired,
    tipoCurso: PropTypes.string.isRequired,
    nomeCurso: PropTypes.string.isRequired,
    data: PropTypes.string.isRequired,
    responsavel: PropTypes.string.isRequired,
    situacao: PropTypes.string.isRequired,
    assinatura: PropTypes.arrayOf([PropTypes.shape({
      ordem: PropTypes.number.isRequired,
      data: PropTypes.string.isRequired,
      responsavel: PropTypes.string.isRequired,
      concluido: PropTypes.bool.isRequired,
    }).isRequired]),
  }).isRequired,
  selectedItems: PropTypes.array.isRequired,
  handleChangeSelection: PropTypes.func.isRequired,
};

export default Row;
